import React, {useEffect, useState} from "react";

const HeroSectionVideo = ({ video_bg}) => {

   const [scrollEffect, setScrollEffect] = useState(0);

   useEffect(() => {
      const handleScroll = () => {
         const scrollY = window.scrollY;
         // Limita el valor de efecto a un rango de 0 a 1
         const effect = Math.min(scrollY / 800, 1);
         setScrollEffect(effect);
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
   }, []);

    return (
        <>
            <div
                className="hero-container drop-in-video"
                style={{
                    opacity: 1 - scrollEffect,
                    borderRadius: `${scrollEffect * 250}px`,
                    padding: scrollEffect > 0 ? "40px" : "0px",
                    transition: "border-radius 0.2s ease, opacity 0.2s ease",
                }}
            >
                <video
                    className="hero-video"
                    autoPlay
                    loop
                    muted
                    playsInline
                    loading="lazy"
                >
                    <source src={video_bg} type="video/mp4" />
                </video>
            </div>


        </>
    )
}

export default HeroSectionVideo